import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from "reactstrap";
import toast from "react-hot-toast";
import CampaignAssignService from "../../../services/OrderingServices/CampaignAssignService";

const UpdateDurationModal = ({
  isOpen,
  toggle,
  ad,
  campaignId,
  onSuccess,
}) => {
  const [duration, setDuration] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && ad) {
      // Initialize with current duration or empty
      setDuration(ad.durationInSeconds || ad.duration || "");
    }
  }, [isOpen, ad]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!duration || duration <= 0) {
      toast.error("Please enter a valid duration greater than 0 seconds");
      return;
    }

    try {
      setLoading(true);
      await CampaignAssignService.updateAdDuration(
        campaignId,
        ad.id,
        parseInt(duration),
      );
      toast.success(`✓ Duration updated to ${duration} seconds!`);
      setDuration("");
      toggle();
      
      // Call onSuccess with adId and new duration for silent update
      if (onSuccess) {
        onSuccess(ad.id, parseInt(duration));
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update duration",
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formatSeconds = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        Update Duration - {ad?.title}
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="duration">Duration (in seconds)</Label>
            <Input
              id="duration"
              type="number"
              min="1"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              placeholder="Enter duration in seconds"
              disabled={loading}
              autoFocus
            />
            <FormText color="muted" className="mt-2">
              {duration && parseInt(duration) > 0
                ? `Approximately: ${formatSeconds(parseInt(duration))}`
                : "Enter a value in seconds"}
            </FormText>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={toggle}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            type="submit"
            disabled={loading || !duration || duration <= 0}
          >
            {loading ? "Updating..." : "Update Duration"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default UpdateDurationModal;
